<template>
  <div class="aqt-table">
    <div class="aqt-table-operation" v-if="sidebar">
      <div class="operation-left">

        <Tooltip v-show="patharr.includes(this.$route.path)" v-if="add" :content="addcontent" placement="bottom">
          <span><Icon type="md-add" size="25" @click="addClick"/></span>
        </Tooltip>
        <Tooltip v-show="!patharr.includes(this.$route.path)" v-if="add" :content="addcontent" placement="bottom">
          <span><Icon type="md-add" size="25" @click="addClick"/></span>
        </Tooltip>

        <Tooltip v-show="patharr.includes(this.$route.path)" v-if="del" content="删除" placement="bottom">
          <span><Icon type="md-trash" size="25" @click="delClick"/></span>
        </Tooltip>
        <Tooltip v-show="!patharr.includes(this.$route.path)" v-if="del" content="删除" placement="bottom">
          <span><Icon type="md-trash" size="25" @click="delClick"/></span>
        </Tooltip>

        <slot name="operationLeft"></slot>
      </div>

      <div class="operation-right">

        <slot name="operationRight"></slot>

        <Tooltip v-if="refresh" content="刷新" placement="bottom">
          <span><Icon type="md-refresh" size="25" @click="refreshClick"/></span>
        </Tooltip>

      </div>
    </div>
    <div class="aqt-table-content" :style="{height:sidebar?'calc(100% - 40px)':'100%'}">
      <div class="table-data" :style="{ bottom: pageDate ? '52px':'10px' }">
        <slot name="table"></slot>
      </div>
      <div class="page-data" v-if="pageDate">
        <div class="page-total">{{ `共 ${pageDate.total} 条` }}</div>
        <div class="page">
          <Page show-elevator :total="pageDate.total" :current="pageDate.current_page" :page-size="Number(pageDate.per_page)"
                :show-sizer="showSizer" @on-page-size-change="pageSizeChange" :page-size-opts="pageSizeOpts"
                @on-change="pageChange" prev-text="上一页" next-text="下一页"/>
        </div>
      </div>
    </div>

    <slot name="others"></slot>
  </div>
</template>

<script>
export default {
  props: {
    pageDate: [Boolean, Object],
    add: {
      type: [Boolean, String],
      default: false
    },
    del: {
      type: [Boolean, String],
      default: false
    },
    refresh: {
      type: Boolean,
      default: false
    },
    sidebar: {
      type: Boolean,
      default: true
    },
    showSizer:{//是否显示每页数量设置
      type: Boolean,
      default: false
    },
    pageSizeOpts:{//是否显示每页数量设置
      type: Array,
      defaultt: function () {
        return [5,10,15,20,25,30,35,40,45,50,55,60]
      }
      // default: [5,10,15,20,25,30,35,40,45,50,55,60]
    },
    addcontent: {
      type: [String],
      default: '添加'
    },
  },
  data() {
    return {
      patharr: ['/device', '/digitalliteraturebookmulu', '/bookmanager', '/digitalliteraturebook', '/digitalliteraturemagazine', '/author', '/translatesystem', '/onlinefullword', '/intellectuallanguage', '/riddle', '/couplet', '/nomadicculture', '/celebrity', '/nationalmusic', '/obos', '/fiveanimal', '/vegetation', '/patternlibrary', '/nomadicculturelinshi', '/catalogorpaper', '/searchallbook', '/mongolianmedicinespaper', '/generalpaper'],
    }
  },
  methods: {

    /*****************************************************************
     *
     * 添加事件
     *
     *****************************************************************/
    addClick() {
      if (this.add) this.$emit('on-add')
    },

    /*****************************************************************
     *
     * 删除事件
     *
     *****************************************************************/
    delClick() {
      if (this.del) this.$emit('on-del')
    },

    /*****************************************************************
     *
     * 刷新事件
     *
     *****************************************************************/
    refreshClick() {
      if (this.refresh) this.$emit('on-refresh')
    },

    /*****************************************************************
     *
     * 分页
     *
     *****************************************************************/
    pageChange(index) {
      this.$emit('on-pageChange', index)
    },
    pageSizeChange(pageSize){
      this.$emit('on-pageSizeChange',pageSize)
    }
  },
  created() {
  },
};
</script>

<style lang="less" scoped>
.aqt-table {
  width: 100%;
  height: 100%;
  position: relative;

  &-operation {
    width: 100%;
    height: 40px;
    position: relative;
    border-bottom: 1px solid #e8eaec;

    .operation-left {
      display: flex;
      align-items: center;
      padding-left: 10px;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;

      span {
        cursor: pointer;
        margin-right: 10px;
      }
    }

    .operation-right {
      display: flex;
      align-items: center;
      padding-right: 10px;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;

      span {
        cursor: pointer;
        margin-left: 10px;
      }
    }
  }

  &-content {
    width: 100%;
    height: calc(~"100% - 40px");
    overflow: hidden;
    padding: 10px;
    position: relative;

    .table-data {
      overflow: auto;
      position: absolute;
      top: 10px;
      left: 10px;
      right: 10px;
      bottom: 52px;
    }

    .page-data {
      height: 42px;
      padding-top: 10px;
      position: absolute;
      left: 10px;
      right: 10px;
      bottom: 10px;
      border-top: 1px solid #e8eaec;

      .page {
        position: absolute;
        top: 9px;
        right: 10px;
        bottom: 10px;
      }

      .page-total {
        height: 32px;
        position: absolute;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>
